import { useState } from "react";
import { saveAs } from "file-saver";
import { useCoastguard } from "@cofano/coastguard2-frontend-client";
import { SailingReportsFilter } from "../SailingReports";

const useDownloadSailingReport = () => {

	const { instance } = useCoastguard();

	const [ loading, setLoading ] = useState(false);

	const getSearchObject = (filter: SailingReportsFilter) => {
		return {
			ship: filter.ship ? filter.ship.map((it) => it.id) : undefined,
			voyageNumber: filter.voyageNumber ?? undefined,
			fromTime: filter.fromTime?.[0] ?? undefined,
			toTime: filter.fromTime?.[1] ?? undefined,
			remark: filter.remark ?? undefined,
		};
	};

	const onDownload = (ids: number[], search: SailingReportsFilter | undefined, all: boolean | undefined) => {
		setLoading(true);

		return instance.fetchBlob("/sailingreports/generate", {
			method: "POST",
			body: {
				sailingReportIds: ids,
				search: search ? getSearchObject(search) : undefined,
				all: all,
			},
			headers: {
				Accept: "application/vnd.ms-excel",
			},
		}).then((blob) => {
			saveAs(blob, "sailing reports.xlsx");
		}).finally(() => {
			setLoading(false);
		});
	};

	return {
		loading: loading,
		onDownload: onDownload,
	};
};

export default useDownloadSailingReport;
